export const getPricesQuery = `
query Prices($search: String, $offset: Int, $limit: Int) {
  prices: filteredPrices(search: $search, limit: $limit, offset: $offset) {
    totalCount
    edges {
      slug
      symbol
      name
      priceUsd
      marketCap
      iconUrlFromInfo
    }
  }
  currencies: searchFiat(limit: 10) {
    fiats {
      id
      icon
      symbol
      name
      priceUsd
    }
  } 
}
`;
